import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { PostLogoResponse } from '../../Models/Models/Settings/PostLogoResponse';
import { CompanyLogo } from '../../Models/Domains/Company/CompanyLogo';

declare var IS_RUNNING_IN_APP_POOL;

export class CustomizeLogoClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public post(logoUrl: string, secondaryLogoUrl: string): Promise<PostLogoResponse, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Settings/CustomizeLogo/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { logoUrl: logoUrl, secondaryLogoUrl: secondaryLogoUrl }

    return AjaxWrapper.post<PostLogoResponse, any>(url, data);
  }
  public get(isAdmin: boolean): Promise<CompanyLogo, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Settings/CustomizeLogo/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { isAdmin: isAdmin }

    return AjaxWrapper.get<CompanyLogo, any>(url, data);
  }
}

